export const formatearFecha = (fecha) => {

    if (!fecha) return "";

    const fechaLimpia = fecha.split("T")[0];

    const [anio, mes, dia] = fechaLimpia.split("-");

    const meses = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
    ];

    return `${dia} de ${meses[parseInt(mes, 10) - 1]} de ${anio}`;
};